export type BitrixAjaxRequestInit = RequestInit & {
  ajaxParam?: boolean;
};

/**
 * Fetch helper for Bitrix ajax handlers.
 * Sends headers Bitrix checks and optional `ajax=y` query param.
 */
export async function bitrixAjaxFetch(
  url: string,
  init: BitrixAjaxRequestInit = {},
): Promise<Response> {
  const requestUrl = new URL(url, window.location.origin);

  if (init.ajaxParam !== false) {
    requestUrl.searchParams.set('ajax', 'y');
  }

  const headers = new Headers(init.headers ?? {});
  headers.set('X-Requested-With', 'XMLHttpRequest');
  headers.set('BX-Ajax', 'Y');

  return fetch(requestUrl.toString(), {
    ...init,
    headers,
  });
}
